import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import { Action, Dispatch } from "redux";
import { createClientCustomerActionCreator } from "../action/client_customer_action";
import ClientCustomerComponent from "../component/client/customer/client_customer";
import {
  createClientCustomerDispatcher,
  IClientCustomerDispatcher,
} from "../dispatcher/client_customer_dispatcher";
import { GetCustomerRequest } from "../request/customer_request";
import { AppState } from "../store/app_state";
import { ClientCustomerState } from "../store/client_customer_state";

interface IProps extends RouteComponentProps<{ customerId: string }> {
  state: ClientCustomerState;
  dispatcher: IClientCustomerDispatcher;
}

interface IState {
  isInit: boolean;
}

export class ClientCustomer extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isInit: true,
    };
  }

  public componentDidMount() {
    const customerId: string = this.props.match.params.customerId;
    const req: GetCustomerRequest = new GetCustomerRequest();
    req.customerId = customerId;
    this.props.dispatcher.getCustomer(req);
  }

  public componentDidUpdate(prevProps: IProps, prevState: IState) {
    // init処理の終了
    const isInitFinished: boolean =
      this.state.isInit &&
      !this.props.state.isLoading &&
      prevProps.state.isLoading;
    if (isInitFinished) {
      return this.setState({ isInit: false });
    }
  }

  public render(): JSX.Element {
    const { state } = this.props;
    const { isInit } = this.state;

    const { customer, jobCareers, company, pastCaseProjects } = state;
    const isLoading: boolean = state.isLoading;

    return (
      <ClientCustomerComponent
        isInit={isInit}
        isLoading={isLoading}
        customer={customer}
        jobCareers={jobCareers}
        company={company}
        pastCaseProjects={pastCaseProjects}
      />
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    state: state.clientCustomerReducer,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {
    dispatcher: createClientCustomerDispatcher(
      dispatch,
      createClientCustomerActionCreator()
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientCustomer);



// WEBPACK FOOTER //
// ./src/presentation/container/client_customer_container.tsx